import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { I18nextProvider } from "react-i18next";
import i18n from "./data/i18n/transalate";
import ReactGA from 'react-ga';
import AppRouter from './AppRouter';
import { render } from 'react-snapshot';

const trackingId = "UA-111616101-1";

ReactGA.initialize(trackingId);

ReactGA.event({
  category: "Website Load",
  action: "Website",
});

render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AppRouter />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
